import React, { useState, useEffect, useContext } from 'react';
import { shape, string, func, arrayOf } from 'prop-types';
import Modal from '@andes/modal';
import { Button, ButtonText } from '@andes/button';
import IconFactory from '../icons/factory-builder';
import StyledLabel from '../styled-label';
import ProgressIndicatorCircular from '@andes/progress-indicator-circular';
import StaticPropsContext from '../context/static-props';
import { trackEvent } from '../../lib/tracking';

const namespace = 'ui-vip-vehicle-history-modal';

const VehicleHistoryModal = ({ label, icon, itemId, modalComponents, fetchModal, track }) => {
  const { deviceType } = useContext(StaticPropsContext);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (modalComponents) {
      setIsLoading(false);
    }
  }, [modalComponents]);

  const openModal = () => {
    if (!modalComponents) {
      setIsLoading(true);
      fetchModal(itemId);
    }
    trackEvent(track);
    setOpen(true);
  };

  return (
    <>
      <Button className={`${namespace}__button`} hierarchy="quiet" onClick={openModal}>
        {IconFactory(icon)}
        <ButtonText>{label}</ButtonText>
      </Button>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="490"
        title=""
        type={deviceType === 'desktop' ? 'small' : 'card'}
        className={`${namespace}__overlay`}
      >
        <div className={`${namespace}__content`}>
          {isLoading ? (
            <ProgressIndicatorCircular modifier="fullscreen" size="large" />
          ) : (
            <>
              <div className={`${namespace}__icon`}>{IconFactory('vehicle_historic_modal')}</div>
              <div className={`${namespace}__title`}>
                <StyledLabel {...modalComponents?.components[1]?.label} />
              </div>
              <div className={`${namespace}__subtitle`}>
                <StyledLabel {...modalComponents?.components[2]?.label} as="span" />
              </div>
              <div className={`${namespace}__actions`}>
                {modalComponents?.components[3]?.actions.map(action => {
                  const {
                    label: { text },
                  } = action;
                  return (
                    <Button
                      key={text}
                      className={`${namespace}__action`}
                      hierarchy="loud"
                      onClick={() => setOpen(false)}
                    >
                      {text}
                    </Button>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </Modal>
    </>
  );
};

VehicleHistoryModal.propTypes = {
  label: string,
  icon: shape({
    id: string,
    color: string,
  }),
  itemId: string,
  modalComponents: shape({
    components: arrayOf(
      shape({
        id: string,
        type: string,
        label: shape({ text: string, color: string, font_size: string, font_family: string }),
        actions: arrayOf(shape({ label: shape({ text: string, color: string }) })),
      }),
    ),
  }),
  fetchModal: func,
  track: shape({ melidata_event: shape({}) }),
};

VehicleHistoryModal.defaultProps = {
  label: '',
  icon: null,
  itemId: '',
  modalComponents: null,
  fetchModal: null,
  track: null,
};

export default VehicleHistoryModal;
